import React from "react";
import SortableTree from "react-sortable-tree";
import FormToastComponent from "../../basics/FormToastComponent";
import LoaderComponent from "../../basics/layout/LoaderComponent";
import { AdditionalFieldOptionRepository } from "../../../repository";

class AdditionalFieldOptionOverviewTreeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            treeData: [],
            isLoading: true,
            index: this.props.index
        }
    }

    componentDidMount() {
        this.setState({ isLoading: false, treeData: this.format(this.props.data) })
    }

    update = (data) =>
        AdditionalFieldOptionRepository.updateTree(this.state.treeData)
            .then(response => {
                FormToastComponent.successTrans("AdditionalFields", "CMS.AdditionalFields.overview.tree.updated")
                this.props.parent.updateData()
            })
            .catch(error => {
                console.error(error.message);
                FormToastComponent.errorTrans("AdditionalFields", "CMS.AdditionalFields.overview.tree.failed")
            });

    format = (array) => {
        let formattedArray = [];

        array.forEach(additionalField => {
            let content = additionalField.contents[this.state.index];
            formattedArray.push({
                title: content.label + '    ( id {' + additionalField.id + '})',
                id: additionalField.id,
                expanded: true
            })
        })

        return formattedArray;
    }

    render() {
        if (this.state.isLoading) return <LoaderComponent />;

        return (
            <div style={{ height: 500 }}>
                <SortableTree
                    treeData={this.state.treeData}
                    onChange={treeData => this.setState({ treeData })}
                    onMoveNode={(data) => this.update(data)}
                    maxDepth={0}
                />
            </div>
        );
    }

}

export default AdditionalFieldOptionOverviewTreeComponent;
